
import {passCodeCheck, passCodeCheckIn, passCodeExtend} from '@/api/studioServices'
export const passCode = {
    state: {
        isCheckinGuest: false,
        checkInData: []
    },
    getters: {
        getIsCheckinGuest: state => state.isCheckinGuest,
        getCheckinData: state => state.checkInData
    },
    mutations: {
        SET_IS_CHECKIN_GUEST(state, isCheckinGuest) {
            state.isCheckinGuest = isCheckinGuest
        },
        SET_CHECKIN_DATA(state, data) {
            state.checkInData = data
        },
        UNSET_CHECKIN_DATA(state) {
            state.checkInData = []
        }

    },
    actions: {
        async PASS_CODE_CHECK({commit}, code){
            try {
                let response = await passCodeCheck(code)
                commit('SET_CHECKIN_DATA', response.data.data)
                return response
            }catch(e) {
                console.log(e.response)
                return e.response
            }
        },
        async PASS_CODE_CHECK_IN(state, code){
            try {
                let response = await passCodeCheckIn(code)
                // console.log(state)
                return response
            }catch(e) {
                console.log(e.response, 'e response')
                return e.response
            }
        },
        async PASS_CODE_EXTEND({dispatch}, code){
            try {
                let response = await passCodeExtend(code)
                if(response && response.status === 200) {
                    dispatch('ADD_ALERT', {type: 'success', text: "User extended"})
                    dispatch('STUDIO_REFRESH_CLIENTS_TABLE');
                } else {
                    dispatch('ADD_ALERT', {type: 'error', text: "Something went wrong"})
                }
                return response
            }catch(e) {
                console.log(e.response, 'e response')
                return e.response
            }
        }
    }
}